import { Box, Typography } from '@mui/material';

import { FHConfirmDialog, FHInputField } from '../../../../../components/base';
import { useDeleteCohortAssignmentModal } from './hooks';

import type { IClientAssignment } from '../../../../../utils/types';

interface DeleteCohortAssignmentModalProps {
  open: boolean;
  assignment: IClientAssignment | null;
  clientId: string | undefined;
  onClose: () => void;
  onDeleted?: () => void;
}

function DeleteCohortAssignmentModal({
  open,
  assignment,
  clientId,
  onClose,
  onDeleted,
}: DeleteCohortAssignmentModalProps) {
  const { password, handlePasswordChange, handleConfirmDelete, isSubmitDisabled } =
    useDeleteCohortAssignmentModal({
      open,
      assignment,
      clientId,
      onClose,
      onDeleted,
    });

  return (
    <FHConfirmDialog
      open={open}
      onClose={onClose}
      title="Delete cohort assignment"
      dialogHeight={320}
      contentRenderer={() => (
        <Box sx={{ my: 2, width: '100%' }}>
          <Typography variant="body2" sx={{ mb: 1 }} textAlign="left">
            Password
          </Typography>
          <FHInputField
            fullWidth
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Enter password"
            inputHeight={40}
          />
        </Box>
      )}
      canceltext="Cancel"
      submittext="Delete Cohort"
      onSubmit={handleConfirmDelete}
      disableSubmitButton={isSubmitDisabled}
    />
  );
}

export default DeleteCohortAssignmentModal;
